import React from 'react'

type IconProps = {
    className?: string
}

export const CompaniesIcon: React.FC<IconProps> = ({ className }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M0.75 12.75H12.75M2.08333 12.75V4.75L5.41667 7.41667V4.75L8.75 7.41667H11.4167M11.4167 7.41667V12.75M11.4167 7.41667L10.4593 1.034C10.4475 0.954965 10.4077 0.88281 10.3471 0.830681C10.2865 0.778552 10.2092 0.749919 10.1293 0.75H9.366C9.28698 0.749879 9.21049 0.777831 9.15017 0.828871C9.08985 0.879911 9.04963 0.95072 9.03667 1.02867L8.08333 6.75M4.75 10.0833H5.41667M8.08333 10.0833H8.75"
            stroke="#3E5060"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)
